__turbopack_context__.v({
  "agency": "ApplyOpenCallChoice-module__8-WJkG__agency",
  "container": "ApplyOpenCallChoice-module__8-WJkG__container",
  "fadeInItems": "ApplyOpenCallChoice-module__8-WJkG__fadeInItems",
  "spacing--lg": "ApplyOpenCallChoice-module__8-WJkG__spacing--lg",
  "spacing--md": "ApplyOpenCallChoice-module__8-WJkG__spacing--md",
  "spacing--sm": "ApplyOpenCallChoice-module__8-WJkG__spacing--sm",
  "spacing--xl": "ApplyOpenCallChoice-module__8-WJkG__spacing--xl",
  "spacing--xs": "ApplyOpenCallChoice-module__8-WJkG__spacing--xs",
  "spacing--xxl": "ApplyOpenCallChoice-module__8-WJkG__spacing--xxl",
  "spacing--xxs": "ApplyOpenCallChoice-module__8-WJkG__spacing--xxs",
  "spacing--xxxl": "ApplyOpenCallChoice-module__8-WJkG__spacing--xxxl",
  "spacing--xxxs": "ApplyOpenCallChoice-module__8-WJkG__spacing--xxxs",
  "text": "ApplyOpenCallChoice-module__8-WJkG__text",
  "title": "ApplyOpenCallChoice-module__8-WJkG__title",
});
